import React from "react";
import "./style.css";

export default function FormPopup({
  show = false,
  text = "",
  onPopupClose = () => {},
}) {
  return (
    <div className={`form-popup ${show && " form-popup--show"}`}>
      <h3 className="form-popup__text">
        {text.length
          ? text
          : "Thank you. \nYour details have been recorded and you will receive a confirmation email shortly."}
      </h3>
      <br />
      <button className="form-popup__close" onClick={onPopupClose}>
        CLOSE
      </button>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/formPopup/index.js